import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { PrimaryButton } from './PrimaryButton';
const checkout = 'https://esl-teacher-ready.impultienda.ar/checkout';
const items = ['120 ready-to-teach English lessons', 'A1 to B1 six-volume progression', 'Speaking, reading, writing, vocabulary, grammar, and listening', 'Teacher guidance, assessments, and answer keys', '5 strategic bonuses included', 'Instant access + 7-day guarantee'];
export function FinalCTA() {
  return <>
      <section className="bg-navy-950 px-4 py-20 text-white sm:py-24" data-id="element-43">
        <div className="mx-auto max-w-4xl rounded-3xl border border-gold-300/60 bg-white/10 p-8 text-center sm:p-12" data-id="element-44">
          <ShieldCheckIcon className="mx-auto text-gold-300" size={56} data-id="element-45" />
          <h2 className="mt-5 font-display text-3xl uppercase leading-tight sm:text-4xl" data-id="element-46">
            Teach with confidence.{' '}
            <span className="text-gold-300" data-id="element-47">Risk-free.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-blue-100" data-id="element-48">
            Open the complete teaching system, explore every resource, and use
            it in your next class. If it is not clear, practical, and useful for
            your teaching, let us know within 7 days.
          </p>
          <p className="mt-5 text-lg font-extrabold text-gold-300" data-id="element-49">
            We will refund 100% of your money. No questions asked.
          </p>
        </div>
      </section>
      <section className="relative overflow-hidden bg-white px-4 py-20 sm:py-28" data-id="element-50">
        <div className="absolute inset-x-0 top-0 h-2 bg-gold-300" data-id="element-51" />
        <div className="mx-auto max-w-5xl text-center" data-id="element-52">
          <p className="text-xs font-extrabold tracking-[.16em] text-gold-500" data-id="element-53">
            YOUR NEXT CLASS CAN FEEL DIFFERENT
          </p>
          <h2 className="mt-4 font-display text-3xl uppercase leading-tight text-navy-950 sm:text-5xl" data-id="element-54">
            Start teaching with{' '}
            <span className="text-gold-500" data-id="element-55">more confidence</span> today.
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-slate-600" data-id="element-56">
            Stop spending your weekends creating lessons from zero. Give
            yourself a complete system that makes planning faster and teaching
            feel more professional.
          </p>
          <div className="mx-auto mt-10 max-w-3xl rounded-3xl border border-[#e6d9b7] bg-ivory p-7 text-left shadow-card sm:p-10" data-id="element-57">
            <h3 className="text-center font-display text-2xl uppercase text-navy-950" data-id="element-58">
              Everything included
            </h3>
            <div className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-59">
              {items.map(item => <p key={item} className="flex gap-2 text-sm font-semibold leading-6 text-slate-700" data-id="element-60">
                  <CheckIcon size={18} className="mt-0.5 shrink-0 text-emerald-500" data-id="element-61" />
                  {item}
                </p>)}
            </div>
            <div className="mt-9 text-center" data-id="element-62">
              <PrimaryButton href={checkout} className="w-full sm:w-auto" data-id="element-63">
                START TEACHING WITH CONFIDENCE
              </PrimaryButton>
              <p className="mt-4 text-xs font-semibold text-slate-500" data-id="element-64">
                Instant digital access • Secure payment • 7-day guarantee
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}